import { useParams } from 'react-router-dom';

import { useCoach } from '@/data/coach';

const Profile = () => {
  const params = useParams();
  const coach = useCoach(params.id);

  return (
    <>
      <h2 className="text-2xl font-bold mb-8">Profile</h2>
      <div className="mb-6">
        <h3 className="text-md font-md text-muted-foreground mb-1">
          Preffered Name
        </h3>
        <p>{coach.data.preferredName}</p>
      </div>
      <div className="mb-6">
        <h3 className="text-md font-md text-muted-foreground mb-1">
          Short Bio
        </h3>
        <p>{coach.data.bioShort}</p>
      </div>
      <div className="mb-6">
        <h3 className="text-md font-md text-muted-foreground mb-1">Full Bio</h3>
        <p>{coach.data.bioFull}</p>
      </div>
    </>
  );
};

export default Profile;
